export const CHALLENGES_LIST_TRYNOW = [
    "develop the resilient system for processing Shopify data updates",
    "create a solution involving Shopify API that would match the existing non-Shopify implementation",
    "create an easy-to-use client for the Core API used across all microservices",
    "optimize queries and other application logic to have utmost performance",
    "keep the unit tests coverage at more than 95%",
    "implement billing system with automatic service cancellation",
]

export const CHALLENGES_LIST_ORBIT = [
    "develop a bounty and application system that is user-friendly and meets the requirements of both recruiters and companies",
    "implement appropriate security measures to safeguard sensitive candidate and employer information",
    "integrate a Slack bot seamlessly with various companies' Slack teams and notifications",
    "establish effective communication channels for recruiters, employers, and candidates throughout the application process",
    "design an efficient application review process that takes into account the needs of all parties involved",
    "optimize queries and application logic to achieve optimal performance",
]

export const CHALLENGES_LIST_GAMETECH = [
    "have shared business logic for Android and iOS",
    "secure data transferring from client to back-end",
    "turn business tasks into technical ones",
    "be fully responsible for the technical part and management of the team",
    "investigate the use of latest technology Kotlin Multiplatform (for iOS part)",
]

export const CHALLENGES_LIST_HELLO = [
    "make the product compatible with many devices",
    "work with legacy code",
    "make a stable product",
    "optimization and performance enhancements",
    "redo database schema without data losing",
]

export const CHALLENGES_LIST_CRAFT = [
    "make fully customized functionality for the user",
    "work effectively with large volumes of tabular data",
    "full-cycle development",
    "make the transition from a site for an individual to an organization",
    "come up with your own metrics based on formulas",
]

export const CHALLENGES_LIST_PEDNET = [
    "explore Flutter at the early stages of its development",
    "platform-specific implementations",
    "learning curve",
    "device compatibility and testing",
    "performance optimization to make app smooth on iOS and Android",
]
